import React from 'react';

const Desktop = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="43"
    height="39"
    viewBox="0 0 43 39"
    fill="none"
  >
    <path
      d="M38.375 23.25V4.5H4.625V23.25H38.375ZM38.375 0.75C39.3696 0.75 40.3234 1.14509 41.0266 1.84835C41.7299 2.55161 42.125 3.50544 42.125 4.5V27C42.125 27.9946 41.7299 28.9484 41.0266 29.6517C40.3234 30.3549 39.3696 30.75 38.375 30.75H25.25L29 36.375V38.25H14V36.375L17.75 30.75H4.625C3.63044 30.75 2.67661 30.3549 1.97335 29.6517C1.27009 28.9484 0.875 27.9946 0.875 27V4.5C0.875 2.41875 2.54375 0.75 4.625 0.75H38.375ZM6.5 6.375H27.125V15.75H6.5V6.375ZM29 6.375H36.5V10.125H29V6.375ZM36.5 12V21.375H29V12H36.5ZM6.5 17.625H15.875V21.375H6.5V17.625ZM17.75 17.625H27.125V21.375H17.75V17.625Z"
      fill="#1F074F"
    />
  </svg>
);

export default Desktop;
